import dialogReducer from './dialogReducer';

export default dialogReducer;